var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/operation-center/conf'},
    {title:'用户列表',path:'/shop/plugin/operation-center/manage'},
    {title:'资金池',path:'/shop/plugin/operation-center/pool'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }